import { Menu, Text } from '@mantine/core';
import { CameraControls } from '@react-three/drei';
import { Icon } from '@uag/react-core';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface FocusBuildingProps {
    cameraControlsRef: RefObject<CameraControls | null>;
    domElement: HTMLCanvasElement | null;
}

export const FocusBuilding = ({ cameraControlsRef, domElement }: FocusBuildingProps) => {
    const { t } = useTranslation();
    const setFocusOnBuilding = usePlacementStore(useShallow((state) => state.setFocusOnBuilding));

    return (
        <Menu.Item
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon="view_in_ar"
                />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right min-w-20 text-[13px]">
                    {ShortcutAction.FocusBuilding}
                </Text>
            }
            onClick={() => setFocusOnBuilding(cameraControlsRef, domElement)}
        >
            {t('buttonFocusBuilding')}
        </Menu.Item>
    );
};
